import { bootstrapApplication } from '@angular/platform-browser';
import * as bootstrap from 'bootstrap';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// The ONE Bootstrap JS copy. Components that need a class import it from 'bootstrap' (this same
// module), never 'bootstrap/js/dist/*': a second copy registers a second data-API, so a
// data-bs-toggle click builds two Modal instances and two backdrops, and hiding one orphans the other.
window.bootstrap = bootstrap;

window.__dfBootStarted?.();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
